import { findAnimationById } from 'Pods/ThreeDStudio/Services/Constants/animations'
import { MODEL_ID, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Inverse of parseTripo3dAnimationDefaultData. Builds an openedModel-shaped
 * payload from the current animateSettings so the just-submitted run can be
 * reopened without an extra API round-trip.
 *
 * The store holds a local library slug but the run row holds the Tripo3D preset
 * name, so the slug is resolved here to keep the optimistic payload identical to
 * the persisted one.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseTripo3dAnimationDefaultData
 */
export const buildTripo3dAnimationDefaultFromState = (state, id) => {
  const { animationId } = state.animateSettings || {}
  const { tripoPreset } = findAnimationById(animationId) || {}

  return {
    id,
    providerKey: PROVIDER.TRIPO3D,
    providerModelId: MODEL_ID.TRIPO3D_ANIMATION_DEFAULT,
    providerRunAttributes: {
      ...(tripoPreset != null && { animation: tripoPreset }),
    },
  }
}
